/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * User role enumeration.
 */
export type UserRole = typeof UserRole[keyof typeof UserRole];


export const UserRole = {
  superadmin: 'superadmin',
  admin: 'admin',
  editor: 'editor',
  publisher: 'publisher',
  user: 'user',
} as const;
